// import { Badge, Col, Container, Row } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// types
import { Feature } from './types';
import { Badge, Col, Container, Row } from 'react-bootstrap';
import Capture from 'assets/images/hero/New folder/Capture.png';
import Capture1 from 'assets/images/hero/New folder/Capture1.png';
import Capture2 from 'assets/images/hero/New folder/Capture2.png';
import leadsDetailsView from 'assets/images/hero/New folder/leadsDetailsView.png';
import salesDash from 'assets/images/hero/New folder/salesDash.png';
import SupportTicketHistory from 'assets/images/hero/New folder/SupportTicketHistory.png';
import campaginDetailsView from 'assets/images/hero/New folder/campaginDetailsView.png';
import AccountsDetailsView from 'assets/images/hero/New folder/AccountsDetailsView.png';
import opportunityDetails from 'assets/images/hero/New folder/opportunityDetails.png';
// import InvoiceForm from 'assets/images/hero/New folder/InvoiceForm.png';
import "./Benefits.css";



import Report4 from 'assets/images/Dashboard/Report4.png'
import salesDashboard from 'assets/images/Dashboard/salesDashboard.png'
import Report03 from 'assets/images/Dashboard/Report03.png'
import Report3 from 'assets/images/Dashboard/Report3.png'

import Capture11 from 'assets/images/Dashboard/Capture11.png'
import Capture12 from 'assets/images/Dashboard/Capture12.png'
import Capture22 from 'assets/images/Dashboard/Capture22.png'
import { useState } from 'react';


type FeaturesProps = {
    features: Feature[];
};

const Features = ({ features }: FeaturesProps) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const slides = [Capture, Capture1, Capture2, leadsDetailsView, salesDash, SupportTicketHistory, opportunityDetails, campaginDetailsView, AccountsDetailsView];


    return (
        <>
            <section className="py-5 mt-5   position-relative">
                <Container>
                    <Row className="mb-5">
                        <Col className="text-center">
                            <Badge bg="primary" pill className="mb-3 px-3 py-2">
                                Features
                            </Badge>

                            <p className="text-muted mt-3">
                                Powerful modules that help your business grow, manage customers, and close more deals.
                            </p>
                        </Col>
                    </Row>

                    <Row className="g-4">
                        {features.map((benefit, index) => (
                            <Col lg={6} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                                <div className="d-flex p-4 bg-white rounded shadow-sm h-100 align-items-start">
                                    <div className="me-4">
                                        <div className="d-flex align-items-center justify-content-center bg-primary bg-opacity-10 text-primary rounded-circle" style={{ width: 48, height: 48 }}>
                                            <FeatherIcon icon={benefit.icon} size={20} />
                                        </div>
                                    </div>
                                    <div>
                                        <h5 className="fw-semibold">{benefit.title}</h5>
                                        <p className="text-muted mb-0">{benefit.description}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            <section className="position-relative py-5">
                <Container>
                    <Row className="justify-content-center text-center mb-5">
                        <Col lg={8}>
                            <h2 className="fw-bold">
                                Performance tracking <span className="text-primary">made easy</span>
                            </h2>
                            <p className="text-muted lead mt-3">
                                Keep track of your pipelines, targets, and team performance
                            </p>
                        </Col>
                    </Row>

                    {/* <div className="dashboard-images text-center position-relative">
     
                        <img
                            src={Capture}
                            alt="Sales Funnel"
                            className="dashboard-img small-img left-img shadow rounded"
                        />

                        <img
                            src={Capture1}
                            alt="Sales Dashboard"
                            className="dashboard-img main-img shadow-lg rounded"
                        />


                        <img
                            src={Capture2}
                            alt="Q1 Goals"
                            className="dashboard-img small-img right-img shadow rounded"
                        />
                    </div> */}
                    <div className="swiper-wrapper-custom">

                        <Swiper
                            modules={[Pagination, Navigation]}
                            slidesPerView={1}
                            loop={true}
                            speed={1200}
                            pagination={{
                                clickable: true
                            }}
                            spaceBetween={0}
                            navigation={{
                                prevEl: ".swiper-button-prev-custom",
                                nextEl: ".swiper-button-next-custom",
                            }}
                            onBeforeInit={(swiper) => {
                                // @ts-ignore
                                swiper.params.navigation.prevEl = ".swiper-button-prev-custom";
                                // @ts-ignore
                                swiper.params.navigation.nextEl = ".swiper-button-next-custom";
                                // @ts-ignore
                            }}
                        >
                            {slides.map((img, idx) => (
                                <SwiperSlide key={idx}>
                                    <img src={img} alt={`slide-${idx}`} className="simple-img" />
                                </SwiperSlide>
                            ))}
                        </Swiper>



                        <div className="swiper-button-prev-custom nav-btn left">‹</div>
                        <div className="swiper-button-next-custom nav-btn right">›</div>
                    </div>

                </Container>
            </section>


        </>
    );
};

export default Features;
